/* global MEDIA_FETCH_COUNT: true */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createPaginationContainer, graphql } from 'react-relay';

import MediaList from './MediaList';

class SuggestionsMediaList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetching: false,
    };
  }

  handleLoadMore = () => {
    if (this.props.relay.isLoading()) {
      return;
    }
    this.setState({ isFetching: true });
    this.props.relay.loadMore(MEDIA_FETCH_COUNT, () => this.setState({ isFetching: false }));
  };

  render() {
    const { isFetching } = this.state;
    const {
      eventHasSearchByFace,
      eventHasSecondFactor,
      suggestionsMedia,
      relay,
      offer,
      participantMediaCount,
      impressionMediaCount,
      startnumber,
    } = this.props;

    return (
      <MediaList
        eventHasSearchByFace={eventHasSearchByFace}
        eventHasSecondFactor={eventHasSecondFactor}
        media={suggestionsMedia.mediaList}
        hasMore={relay.hasMore()}
        isFetching={isFetching}
        onLoadMore={this.handleLoadMore}
        offer={offer}
        participantMediaCount={participantMediaCount}
        impressionMediaCount={impressionMediaCount}
        listType="suggestions"
        startnumber={startnumber}
      />
    );
  }
}

SuggestionsMediaList.propTypes = {
  eventHasSearchByFace: PropTypes.bool,
  eventHasSecondFactor: PropTypes.bool,
  customerKey: PropTypes.string,
  suggestionsMedia: PropTypes.object, // relay
  offer: PropTypes.object, // relay
  participantMediaCount: PropTypes.number,
  impressionMediaCount: PropTypes.number,
  startnumber: PropTypes.string,
  relay: PropTypes.object,
};

export { SuggestionsMediaList };

export default createPaginationContainer(
  SuggestionsMediaList,
  {
    suggestionsMedia: graphql`
      fragment SuggestionsMediaList_suggestionsMedia on ExtendedMediaConnection {
        mediaList(first: $count, after: $cursor)
          @connection(key: "SuggestionsMediaList_mediaList") {
          edges {
            node {
              id
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
          ...MediaList_media
        }
      }
    `,
    offer: graphql`
      fragment SuggestionsMediaList_offer on Event {
        ...MediaList_offer
      }
    `,
  },
  {
    direction: 'forward',
    // Function that should indicate which connection to paginate over, given the fragment
    // props.
    getConnectionFromProps(props) {
      return props.suggestionsMedia && props.suggestionsMedia.mediaList;
    },
    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, paginationInfo, fragmentVariables) {
      return {
        eventId: props.eventId,
        startnumber: props.startnumber,
        count: paginationInfo.count,
        cursor: paginationInfo.cursor,
        secondFactor: props.customerKey,
      };
    },
    query: graphql`
      query SuggestionsMediaListQuery(
        $eventId: ID!
        $startnumber: ID!
        $count: Int!
        $cursor: String
        $secondFactor: String
      ) {
        viewer {
          event(id: $eventId) {
            participant(startnumber: $startnumber, secondFactor: $secondFactor) {
              suggestions {
                ...SuggestionsMediaList_suggestionsMedia
              }
            }
          }
        }
      }
    `,
  },
);
